import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Spin from 'components/ui/Spin'
import AccountProfileForm from './AccountProfileForm/AccountProfileForm'
import {
  fetchAccountProfile,
  getAccountProfile,
  isFetching,
  updateAccountProfile,
  fetchAccountProfileOptions,
  getAccountProfileOptions
} from './accountProfileReducer'

class AccountProfileContainer extends Component {

  componentDidMount() {
    this.props.fetchAccountProfile()
    this.props.fetchAccountProfileOptions()
  }

  render() {
    const { isFetching, handleSubmit } = this.props

    if (isFetching) {
      return <Spin />
    } else {
      return <AccountProfileForm onSubmit={handleSubmit} />
    }
  }
}

const mapStateToProps = state => ({
  profile: getAccountProfile(state),
  options: getAccountProfileOptions(state),
  isFetching: isFetching(state)
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchAccountProfile,
    fetchAccountProfileOptions,
    handleSubmit: values => updateAccountProfile(values)
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(AccountProfileContainer)



// WEBPACK FOOTER //
// ./src/features/Account/accountProfile/AccountProfileContainer.jsx